import { PrinterStatus, SimplePrinterStatus } from 'Interfaces';

export default function simplifyPrinterStatus(status: PrinterStatus, isStopped: boolean): SimplePrinterStatus {
  if (isStopped) return 'stopped';
  if (status === 'idle' || status === 'unknown') return 'ready';
  if (status === 'processing') return 'processing';
  return 'stopped';
}
